

































































import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    VuePerfectScrollbar,
  },
})
export default class MainMenu extends Vue {
  get auth() {
    return this.$store.state.authenticated;
  }

  authenticated = false;

  @Watch("auth", { immediate: true, deep: true })
  onAuthChange() {
    this.authenticated = this.auth;
  }
}
